'use strict';

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

require('proto-polyfill');

var _eventUtility = require('@nimius/event-utility');

var _domUtility = require('@nimius/dom-utility');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _eventUtility.onPageLoadComplete)(function () {
    var _loop = function _loop(element) {

        // Extract settings
        var settings = (0, _domUtility.extractPrefixedAttributesFromElement)(element, 'data-swiper-');
        settings.slideClass = settings.slideClass || 'swiper-slide';
        settings.slidesPerView = settings.slidesPerView || 1;
        var childrenCount = element.querySelectorAll('.' + settings.slideClass).length;

        // Remove the whole slider, if there is no content.
        if (childrenCount === 0) {
            element.remove();
        }

        if (childrenCount <= settings.slidesPerView) {
            // Remove navigation arrows, if there is only one slide.
            element.querySelector(settings.nextButton).remove();
            element.querySelector(settings.prevButton).remove();
            element.querySelector(settings.pagination).remove();
        } else {
            // Setup navigation arrow handlers if not
            var nextButton = element.querySelector(settings.nextButton);
            var prevButton = element.querySelector(settings.prevButton);

            if (nextButton) {
                nextButton.addEventListener('click', function () {
                    return element._swiper.slideNext();
                });
            }
            if (prevButton) {
                prevButton.addEventListener('click', function () {
                    return element._swiper.slidePrev();
                });
            }
        }

        // Fetch swiper instance, if settings.control is set
        if (settings.control) {
            var controlSwiperElement = document.querySelector(settings.control);
            delete settings.control;

            if (controlSwiperElement._swiper) {
                // If the control swiper has been initialized previously,
                // then the instance is already available.
                settings.control = controlSwiperElement._swiper;
            } else {
                // If the control swiper has not been initialized previously,
                // then we have to wait for it to be initialized.
                controlSwiperElement.addEventListener('nimcore.swiper.initialized', function (event) {
                    element._swiper.params.control = event.detail.swiper;
                });
            }
        }

        import( /* webpackChunkName: "swiper.async" */'swiper').then(function (Swiper) {
            // Initialize the swiper.
            element._swiper = new Swiper(element, settings);

            // Trigger the event
            (0, _eventUtility.fireEvent)(element, 'nimcore.swiper.initialized', {
                swiper: element._swiper,
                settings: settings
            });
        });
    };

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = (0, _getIterator3.default)(document.querySelectorAll('[data-swiper]')), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var element = _step.value;

            _loop(element);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}); // Polyfill for __proto__ usage in Swiper.js.
// This is only needed for IE10 Support and can be removed, once
// IE10 Support is being dropped.


//////////////////
// WEBPACK FOOTER
// ./Resources/Private/Javascript/swiper.js
// module id = 108
// module chunks = 2